import { Localization, Permission } from '@/models';
import { RootStore } from '@/store';
import { containsAllFrom } from '@/utils';
import {
  ROUTES_GLOBAL,
  ROUTES_PL,
} from './index';
import Vue from 'vue';
import Router, { RouteConfig, Location, Route } from 'vue-router';

export type RouterLocation = (routerLocation?: Location) => void;

Vue.use(Router);

function isRouteAccessible(route: RouteConfig) {
  return route.meta?.requiredPermissions
    && containsAllFrom(route.meta.requiredPermissions, RootStore.state.geek.current.permissions);
}

// Temporary solution until razor is used
function getExistingRoute(adminRoutes: RouteConfig[], path: string): RouteConfig {
  return adminRoutes.find(e => e?.path === path) as RouteConfig;
}

export class RouterFactory {
  public static build(localization: Localization = Localization.Poland): Router {
    switch (localization) {
      case Localization.Poland:
        this.routes = ROUTES_PL;
        break;
      case Localization.Global:
        this.routes = ROUTES_GLOBAL;
        break;
      default:
        this.routes = ROUTES_PL;
    }

    return new Router({
      mode: 'history',
      routes: this.routes,
      linkActiveClass: 'active',
    });
  }

  private static routes: RouteConfig[] = [];
}
